"use client";
import Image from "next/image";
import { Layout } from "@/components/Layout/Layout";
import { LeadershipTab } from "@/components/LeadrershipTab/LeadershipTab";
import { HeroBanner } from "@/components/HeroBanner/HeroBanner";
import { SectionHeading } from "@/components/SectionHeading/SectionHeading";
import HTMLReactParser from "html-react-parser";
import { getImageSrc } from "@/app/utils/getImageSrc";
import { Button } from "@/components/Button/Button";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";
import Link from "next/link";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Timeline } from "@/components/Timeline/Timeline";

const jsonLd = {
	"@context": "https://schema.org",
	"@type": "Person",
	name: "Ratul Puri",
	alternateName: "Ratul Puri Chairman Hindustan Power",
	url: "https://www.example.com/ratulpuri-chairman-hindustan-power",
	image: "https://www.example.com/images/ratul-puri.jpg",
	description: "Ratul Puri is the Chairman of Hindustan Powerprojects, a leading energy company specializing in solar and thermal energy.",
	jobTitle: "Chairman",
	worksFor: {
		"@type": "Organization",
		name: "Hindustan Powerprojects Private Limited",
		url: "https://www.hindustanpowerprojects.com",
	},

	knowsAbout: [
		"Renewable Energy",
		"Solar Power",
		"Infrastructure Development",
	],

	sameAs: [
		"https://www.linkedin.com/in/ratulpuri/",
		"https://en.wikipedia.org/wiki/Ratul_Puri",
	],
};

export default function Wrapper({ pageData }) {
	return (
		<Layout>
			<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />
			<HeroBanner image={getImageSrc(pageData.banner.image.url)} title={pageData.banner.title} about={HTMLReactParser(pageData.banner.text)} mobileImage={getImageSrc(pageData.banner.mobileImage.url)} alt={pageData.banner.image?.alt || "About Hindustan Power"} mobileAlt={pageData.banner.mobileImage?.alt || "About Hindustan Power"} />

			<section className="py-12 lg:py-24">
				<div className="hp-container items-center gap-8 grid grid-cols-1">
					<div className="grid grid-cols-1 gap-8 xl:grid-cols-2 xl:gap-40">
						<h2 className="text-[24px] lg:text-[30px] font-normal text-black leading-[34px] lg:leading-[40px]">{HTMLReactParser(pageData.intro.title)}</h2>
						<p className="font-normal text-[14px] lg:text-[16px] xl:text-[18px]  leading-[22px] lg:leading-[28px] text-gray">{HTMLReactParser(pageData.intro.text)}</p>
					</div>
				</div>

				<div className="hp-container grid grid-cols-1 items-start pt-8 lg:pt-24">
					<div className="flex items-start xl:items-center justify-bewteen flex-col xl:flex-row gap-5 xl:gap-40 py-12 border-t border-b border-black">
						<div className="">
							<div className="py-2.5 px-12 rounded-[20px] font-normal text-primary text-[14px] lg:text-[16px] xl:text-[18px]  border border-red w-40 flex justify-center">{HTMLReactParser(pageData.intro.mission.title)}</div>
						</div>
						<h2 className="text-[24px] lg:text-[30px] font-normal text-black leading-[30px] lg:leading-[40px] ">{HTMLReactParser(pageData.intro.mission.text)}</h2>
					</div>
					<div className="flex items-start xl:items-center justify-bewteen flex-col xl:flex-row gap-5 xl:gap-40 py-12 border-b border-black">
						<div className="">
							<div className="py-2.5 px-12 rounded-[20px] font-medium text-primary text-[14px] lg:text-[16px] xl:text-[18px]  border border-red w-40 flex justify-center">{HTMLReactParser(pageData.intro.vision.title)}</div>
						</div>
						<h2 className="text-[24px] lg:text-[30px] font-normal text-black leading-[30px] lg:leading-[40px]">{HTMLReactParser(pageData.intro.vision.text)}</h2>
					</div>
				</div>
			</section>

			<section className="pt-16 lg:pt-0 bg-primary text-white radial-gradient-mobile lg:radial-gradient overflow-hidden">
				<div className="hp-container flex flex-col items-center ">
					<div className="grid grid-cols-12 lg:gap-8 w-full items-center">
						<div className="col-span-12 lg:col-span-5">
							<div className="text-left flex flex-shrink-0 gap-2 items-start mb-5 ">
								<div className="flex flex-col gap-5">
									<h2 className="text-[24px] lg:text-[30px] font-normal text-white leading-[30px] lg:leading-[40px] ">
										<span>{HTMLReactParser(pageData.ratulPuri.title)}</span>
									</h2>
									<p className="font-light text-[14px] lg:text-[16px] xl:text-[18px]  leading-[22px] lg:leading-[28px] ">{HTMLReactParser(pageData.ratulPuri.text)}</p>
								</div>
							</div>
							<div className="pl-8">
								<div className="h-[1px] bg-red w-full my-5"></div>
								<div className="flex flex-col gap-2">
									<h4 className="text-[24px] lg:text-[30px] font-normal text-white leading-[30px] lg:leading-[40px]">{HTMLReactParser(pageData.ratulPuri.name)}</h4>
									<h6 className="text-[14px] lg:text-[16px] xl:text-[18px]  font-thin">{HTMLReactParser(pageData.ratulPuri.designation)}</h6>
									<div className="mt-4">
										<Link href={`/leadership/ratul-puri`} className="bg-white text-primary py-2 px-4 rounded inline-block font-medium">Profile</Link>
									</div>
								</div>
							</div>
						</div>
						<div className="col-span-12 lg:col-span-7 ">
							<div className="h-full">
								<Image alt={pageData.ratulPuri.image?.alt || "Ratul Puri, Chairman of Hindustan Power"} src={getImageSrc(pageData.ratulPuri.image.url)} width={100} height={80} unoptimized className="w-full h-[600px] lg:h-[850px] object-contain -mb-20" />
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="py-8 lg:py-16">
				<div className="hp-container flex flex-col items-center">
					<SectionHeading heading={HTMLReactParser(pageData.values.title)} subHeading={HTMLReactParser(pageData.values.text)} />
					<div className="hidden lg:flex flex-wrap justify-center gap-5 xl:gap-12 py-8 w-full">
						{pageData.values.values.map((value, key) => {
							return (
								<div className="flex flex-col gap-2 lg:gap-5 justify-center items-start py-12 px-12 rounded-[15px] bg-blue md:w-[30.33%]" key={key}>
									<Image alt={value.image?.alt || "Hindustan Power core value icon"} src={getImageSrc(value.image.url)} width={60} height={60} unoptimized className="" />
									<h4 className="text-[16px] lg:text-[30px] font-medium leading-[26px] lg:leading-[36px]">{HTMLReactParser(value.title)}</h4>
									<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">{HTMLReactParser(value.text)}</p>
								</div>
							);
						})}
					</div>

					<div className="w-full beneficiary-slider block lg:hidden">
						<Swiper loop={false} pagination={{ clickable: true }} modules={[Pagination]} spaceBetween={15} slidesPerView={1.15} breakpoints={{ 640: { slidesPerView: 2.1, }, 1024: { slidesPerView: 3.1, }, }}>
							{pageData.values.values.map((value, key) => {
								return (
									<SwiperSlide key={key}>
										<div className="flex flex-col gap-2 lg:gap-5 justify-center items-start py-12 px-12 rounded-[15px] bg-blue">
											<Image alt={value.image?.alt || "Hindustan Power core value icon"} src={getImageSrc(value.image.url)} width={60} height={60} unoptimized className="w-12 h-12" />
											<h4 className="text-[16px] lg:text-[26px] font-medium leading-[26px] lg:leading-[36px]">{HTMLReactParser(value.title)}</h4>
											<p className="text-[14px] lg:text-[16px] xl:text-[18px]  font-normal">{HTMLReactParser(value.text)}</p>
										</div>
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			</section>

			<section className="py-8 md:py-16 z-0 relative">
				<div className="hp-container flex flex-col items-center pb-8">
					<SectionHeading heading={HTMLReactParser(pageData.timeline.title)} subHeading={HTMLReactParser(pageData.timeline.text)} />
				</div>
				<Timeline timeline={pageData.timeline.timeline} />
			</section>

			<section className="xl:py-16 pb-16 z-10 relative">
				<div className="hp-container flex flex-col items-start">
					<div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-0">
						<div className="border-b md:border-b-0 md:border-r border-[#D2D2D2] md:pr-8 lg:pr-32 pb-16 lg:pb-0">
							<div className="flex flex-col gap-5 lg:gap-16 mb-5">
								<h2 className="text-[28px] xl:text-[50px] font-medium leading-[38px] md:leading-[60px]">{HTMLReactParser(pageData.policy.posh.title)}</h2>
								<p className="font-normal text-[14px] lg:text-[16px] xl:text-[18px] ">{HTMLReactParser(pageData.policy.posh.text)}</p>
							</div>
							<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0] flex-grow-0" href={getImageSrc(pageData.policy.posh.doc.url)} target="_blank">
								<Image alt="POSH policy PDF icon" src="/pdf.svg" width={30} height={30} unoptimized className="object-contain" />
								<span>View Policy</span>
							</Link>
						</div>
						<div className="md:pl-8 xl:pl-32">
							<div className="flex flex-col gap-5 lg:gap-16 mb-5">
								<h2 className="text-[28px] xl:text-[50px] font-medium leading-[38px] md:leading-[60px]">{HTMLReactParser(pageData.policy.opportunity.title)}</h2>
								<p className="font-normal text-[14px] lg:text-[16px] xl:text-[18px] ">{HTMLReactParser(pageData.policy.opportunity.text)}</p>
							</div>
							<Link className="bg-white text-black py-1.5 px-6 rounded-[30px] font-bold text-[14px] lg:text-[16px] xl:text-[18px]  inline-flex gap-2 items-center border border-[#D0D0D0] flex-grow-0" href={getImageSrc(pageData.policy.opportunity.doc.url)} target="_blank">
								<Image alt="Equal opportunity policy document icon" src="/image.svg" width={30} height={30} unoptimized className="object-contain" />
								<span>View Policy</span>
							</Link>
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
}
